import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router/'
import store from './store/'

import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import VueMathjax from 'vue-mathjax'
import FlagIcon from 'vue-flag-icon'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(FlagIcon)

Vue.use(VuejsDialog)
Vue.use(VueMathjax)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBXHTApQxC7eBOhAUSi5kiniwnOdztCyKY',
    region: 'RO',
    language: 'ro'
    // v: '3.10'
  }
})

Vue.config.productionTip = false

Vue.filter('number', value => isNaN(value) ? (value === null || value === undefined ? value : 'Not a Number') : (+value).toLocaleString('ro-RO', { minimumFractionDigits: 0, maximumFractionDigits: 12 }))
Vue.filter('intNumber', value => isNaN(value) ? (value === null || value === undefined ? value : 'Not a Number') : (+value).toLocaleString('ro-RO', { minimumFractionDigits: 0, maximumFractionDigits: 0 }))

Vue.filter('shortDate', value => {
  const parsed = Date.parse(value)
  if (!isNaN(parsed)) {
    const options = {
      year: 'numeric', month: 'numeric', day: 'numeric'
    }

    if (value.length > 10) {
      options.hour = 'numeric'
      options.minute = 'numeric'
      options.second = 'numeric'
    }

    return (new Date(parsed)).toLocaleDateString('ro-RO', options)
  }
  return 'Data invalida...'
})
Vue.filter('longDate', value => {
  const parsed = Date.parse(value)
  if (!isNaN(parsed)) {
    const options = {
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
    }

    if (value.length > 10) {
      options.hour = 'numeric'
      options.minute = 'numeric'
      options.second = 'numeric'
    }

    return (new Date(parsed)).toLocaleDateString('ro-RO', options)
  }
  return 'Data invalida...'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
